import { useNavigate } from 'react-router-dom';

import { ScheduleTemplateResp } from '@api/responseModels/worker/schedule/scheduleTemplateResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { getStartDate } from '../common/helpers';
import { TScheduleTemplatePanelState, TState } from '../schedule';

export function useSaveAndApplyTemplate({
    crmID,
    workerPositionID,
    state,
    validateSchedule,
    messageApi,
    messageService,
    stpState,
}: {
    state: TState;
    crmID: string | number;
    workerPositionID: string | number;
    validateSchedule: () => boolean;
    messageApi: any;
    messageService: any;
    stpState: TScheduleTemplatePanelState;
}) {
    const navigate = useNavigate();

    const saveAsTemplateAndUpdateScheduleFromTemplate = async (title?: string) => {
        if (!validateSchedule()) return;
        state.isLoading = true;

        try {
            const result = await CRMAPIManager.request<ScheduleTemplateResp>(async (api) => {
                return await api.saveScheduleTemplate({
                    crm_id: state.schedule.crm_id,
                    id: null,
                    title,
                    start_time: state.schedule.start_time,
                    end_time: state.schedule.end_time,
                    breaks: state.schedule.breaks,
                    day_offs: state.schedule.day_offs,
                    schedules: [],
                    schedule_days: state.schedule.schedule_days,
                    schedule_type: state.schedule.schedule_type,
                    exception_days: state.schedule.exception_days,
                });
            });

            if (result.errorCode) throw result.errorCode;

            messageApi.success('Сохранено как шаблон');
            const temp = result.data.data;

            const result2 = await CRMAPIManager.request<ScheduleTemplateResp>(async (api) => {
                return await api.updateSchedule(+crmID, state.scheduleOrigin.id, {
                    title: temp.title,
                    start_time: temp.start_time,
                    end_time: temp.end_time,
                    breaks: temp.breaks,
                    day_offs: temp.day_offs,
                    schedule_days: temp.schedule_days ?? [],
                    schedule_type: temp.schedule_type,
                    exception_days: temp.exception_days,
                    start_schedule_at: getStartDate(state.scheduleOrigin),
                });
            });

            if (result2.errorCode) throw result2.errorCode;

            stpState.selectedTemplateId = null;
            messageApi.success('График обновлён');
            navigate(`/lk/worker/crm/${crmID}/workers/${workerPositionID}/schedule`);
        } catch (err) {
            messageService.sendErrorList(err);
            console.log(err);
        }

        state.isLoading = false;
    };

    return { saveAsTemplateAndUpdateScheduleFromTemplate };
}
